/**
 * URL guard for anchor `href` values.
 *
 * The BB API's `user_links[].uri` is first-party, but interpolating it straight
 * into an `href` still lets a compromised/misconfigured `/mine` payload inject a
 * `javascript:`/`data:`/`vbscript:` one-click script-execution vector. This guard
 * is defense-in-depth: dangerous schemes collapse to `"#"`; everything else
 * (http(s), protocol-relative, root/relative, fragment, mailto/tel) passes through.
 *
 * @param uri - raw URL from external data (may be null/undefined)
 * @returns a URL safe to place in `href`, or `"#"` for a dangerous/absent scheme
 */
const DANGEROUS_SCHEME_RE = /^\s*(?:javascript|data|vbscript):/i;

// Browsers strip ASCII tab and newlines and ignore other C0 control chars when
// resolving a URL scheme, so a scheme split by a control char (e.g. a tab inside
// "javascript:") still executes. Strip them before scheme detection.
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS_RE = /[\u0000-\u001f\u007f]/g;

export function safeHref(uri: string | null | undefined): string {
  if (uri == null) {
    return "#";
  }
  const scheme = uri.replace(CONTROL_CHARS_RE, "");
  return DANGEROUS_SCHEME_RE.test(scheme) ? "#" : uri;
}
